import { defineComponent as _defineComponent } from 'vue';
import { DialogClose } from "reka-ui";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SheetClose',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: null, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get DialogClose() { return DialogClose; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
